<div class="form-group row" *ngIf="control.visible" [formGroup]="formGroup">
  <div class="col-md-12">
    <hb-df-control-label [control]="control" (onOverrideValue)="overrideValue()"></hb-df-control-label>
  </div>
  <div class="col-md-12">
    <input
      class="form-control"
      type="{{ control.type }}"
      [id]="control.key"
      [placeholder]="control.placeholder || control.label"
      [formControlName]="control.key"
      [disabled]="control.disabled"
      [autocomplete]="control.allowBrowserAutocomplete ? 'on' : 'off'"
      attr.list="{{ control.key }}-list"
    />
    <datalist id="{{ control.key }}-list">
      <option *ngFor="let opt of control.options" [value]="opt">{{ opt }}</option>
    </datalist>
  </div>
</div>
